import serviceBase from '../../../../Services/serviceBase'

class NewsAndAnnouncementsActions {
  getNews = async (legacyId, dateFrom = undefined) => {
    const url = `${window._env_.COMMUNITY_API_URL}/news-and-announcements/news-detail-by-identifier/${legacyId}/${dateFrom ?? 0}`
    try {
      const response = await serviceBase.get(url)
      return response?.data
    } catch (error) {
      return
    }
  }

  blockedNews = async (fireDepartmentId) => {
    let url = `${window._env_.COMMUNITY_API_URL}/news-and-announcements/blocked-news/${fireDepartmentId}`
    try {
      const response = await serviceBase.get(url)
      return response?.data
    } catch (error) {
      return
    }
  }

  deleteNews = async (ids) => {
    let url = `${window._env_.COMMUNITY_API_URL}/news-and-announcements/delete-news`
    try {
      const response = await serviceBase.post(url, { ids: ids })
      return response?.status === 200
    } catch (error) {
      return
    }
  }
}

export default new NewsAndAnnouncementsActions()
